import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-corporate-notify-driver",
  templateUrl: "./admin-corporate-notify-driver.component.html",
  styleUrls: ["./admin-corporate-notify-driver.component.css"],
})
export class AdminCorporateNotifyDriverComponent implements OnInit {
  notifyform: FormGroup;
  workorderArray: any;
  token: any;
  vehicleArray: any;
  selectedWorkOrderQty: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  total_quantity: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckTypeNumber: any = -1;
  startPage: any = 1;
  page: any = -1;
  perPage: any = 100;
  loading: boolean = false;
  truckTypeList: any;
  workOrderQnty: any;
  work_order_qty: any;
  cityData = [];
  searchQuery: any = -1;
  searchtripID: any = -1;
  tripType: any = "-1";
  dropAutoComplete: any;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  completeDropAddress: any;
  completePickUpAddress: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  drop_long_name: any = "";
  drop_short_name: any = "";
  pickup_postal_code: any;
  dropoff_postal_code: any;
  selectedValue: string | null = null;
  isAllTransporters: boolean = false;
  isFormDisabled = false;
  isNotificationRadiusDisabled = false;
  isKmsDisabled = false;
  isTruckLocationDisabled = false;
  isTimerDisabled = false;
  selectedOption: string = "";
  radioButtonSelected: any;

  gettingData: any = [];
  truck_weight: any;
  selectedLoadedQuantity: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  truckCategory: any = [];
  selectedTripType: number = -1;
  truckCatgNumber: number = -1;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminCorporateNotifyDriverComponent>,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.truckCategoryGet(this.selectedTripType, this.truckCatgNumber);

    this.notifyform = this.formBuilder.group({
      workorder_id: [""],
      work_order_quantity: [""],
      from_city_name: [""],
      material_type: [""],
      to_city_name: [""],
      max_trip: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]+$/),
        ]),
      ],
      truck_category_name: [""],
      trip_booking_date: ["", [Validators.required]],
      // truck_category: ["", [Validators.required]],
      // trip_id: [""],
      timer: [""],
      truck_weight: [""],
      // radio_selection: [""],
      // selectedOption: ["", Validators.required],
      notificationRadius: [""],
      notification_radius: [""],
      all_transporters: [""],
      allTransporters: [""],
      truck_home_location: [""],
      truckHomeLocations: [""],
    });
    this.workOrder();
    // this.tripslist();
    this.getMasterData();
    this.GetTruckType(this.truckTypeNumber);
  }

  // ngAfterViewInit(): void {
  //   var options = {
  //     componentRestrictions: { country: "in" },
  //   };
  //   this.pickupAutoComplete = new google.maps.places.Autocomplete(
  //     this.pickUpLocation.nativeElement,
  //     options
  //   );
  //   this.dropAutoComplete = new google.maps.places.Autocomplete(
  //     this.dropLocation.nativeElement,
  //     options
  //   );
  // }
  close() {
    this.matdialogref.close();
  }
  getMasterData() {
    this.services.GetMasterList(this.token).subscribe((resp) => {
      //@ts-ignore
      //@ts-ignore
      this.cityData = [...resp.body.data.toCityDetail];
    });
  }
  workOrder() {
    this.services.ListWorkOrder(this.token).subscribe(
      (response: any) => {
        this.vehicleArray = response.body.data;
        this.workorderArray = response.body;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  tripslist() {
    this.services
      .GetAdminTrips(
        this.token,
        this.startPage,
        this.perPage,
        this.searchQuery,
        this.searchtripID,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          this.vehicleArray = response.body.data;
          this.workorderArray = response.body.data;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  onNotificationRadiusChange(value: any) {
    if (value) {
      this.isFormDisabled = true;
      this.isTruckLocationDisabled = false;
    } else {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = false;
    }
  }
  onSelectionChange(option: string) {
    this.selectedOption = option;
    if (option === "notificationRadius") {
      this.notifyform.get("notification_radius")?.enable();
      this.notifyform.get("truck_home_location")?.disable();
      this.notifyform.get("truck_home_location")?.setValue("");
    } else if (option === "truckHomeLocations") {
      this.notifyform.get("notification_radius")?.disable();
      this.notifyform.get("notification_radius")?.setValue("");
      this.notifyform.get("truck_home_location")?.enable();
    } else if (option === "allTransporters") {
      this.notifyform.get("notification_radius")?.disable();
      this.notifyform.get("truck_home_location")?.disable();
      this.notifyform.get("notification_radius")?.setValue("");
      this.notifyform.get("truck_home_location")?.setValue("");
      // this.notifyform.get("all_transporters")?.enable();
    }
  }

  onTruckHomeLocationChange(event: any) {
    if (event.value) {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = true;
    } else {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = false;
    }
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }
  onInputPickUpchange() {
    this.geoCodePickUp(this.notifyform.value.pickup);
  }
  onDropChange() {
    this.geoCodeDrop(this.notifyform.value.drop);
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completePickUpAddress = result[0];
                this.pickup_short_name = "";
                this.pickup_long_name = "";
                for (
                  let i = 0;
                  i < this.completePickUpAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.pickup_short_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completePickUpAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.pickup_long_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.pickup_postal_code = Number(
                      this.completePickUpAddress.address_components[i].long_name
                    );
                  }
                  if (this.pickup_short_name && this.pickup_long_name) {
                    this.notifyform.controls["pickup"].setValue(
                      `${this.completePickUpAddress.formatted_address}`
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completeDropAddress = result[0];
                this.drop_short_name = "";
                this.drop_short_name = "";
                for (
                  let i = 0;
                  i < this.completeDropAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.drop_short_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completeDropAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.drop_long_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.dropoff_postal_code = Number(
                      this.completeDropAddress.address_components[i].long_name
                    );
                  }
                  if (this.drop_short_name && this.drop_long_name) {
                    this.notifyform.controls["drop"].setValue(
                      `${this.completeDropAddress.formatted_address}`
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  selectChangeHandler(item: any) {
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = this.notifyform.value.workorder_id;
    this.services
      .selectedWorkOrder(_id, this.token)
      .subscribe((response: any) => {
        this.gettingData = response.body.data;
        console.log("<<<>>>", response.body.data);

        console.log("res", response.body.data[0].total_tons);
        this.notifyform.patchValue({
          work_order_quantity: response.body.data[0].total_tons,
          price_per_ton: response.body.data?.price_per_ton,
          // work_order_date: this.formatFormDate(response.body.data?.createdAt),
        });
        // this.notifyform.patchValue({
        //   price_per_ton: response.body.data.price_per_ton,
        //   work_order_date: this.formatFormDate(response.body.data.createdAt),
        //   work_order_quantity: response.body.data[0].total_tons,
        // });
        this.total_quantity = response.body.data.remaining_tons;
      });
    this.notifyform
      .get("from_city_name")
      ?.patchValue(item.pickup_details?.from_city_name);
    this.notifyform
      .get("to_city_name")
      ?.patchValue(item.dropoff_details?.to_city_name);
    this.notifyform.get("material_type")?.patchValue(item.material_type);
  }
  // selectChangeHandlerTruckcategory(item: any) {
  //   this.notifyform.patchValue({
  //     truck_weight: item.truck_weight,
  //   });
  // }
  // selectChangeHandlerTruckcategory(item: any) {
  //   const weight = this.extractNumber(item.truck_weight);
  //   this.notifyform.patchValue({
  //     truck_weight: weight,
  //   });
  // }

  selectChangeHandlerTruckcategory(item: any) {
    let weight = this.extractNumber(item.truck_weight);
    // Check if the weight is in kilograms
    if (item.truck_weight_unit === "kgs" || item.truck_weight_unit === "kg") {
      weight = this.convertKgToTons(weight);
    }
    this.notifyform.patchValue({
      truck_weight: weight,
    });
  }
  convertKgToTons(weightInKg: number): number {
    return weightInKg / 1000; // 1 ton = 1000 kilograms
  }
  extractNumber(input: string): number {
    const numberPattern = /\d+/;
    const match = input.match(numberPattern);
    return match ? parseInt(match[0], 10) : 0; // Default to 0 if no match is found
  }

  public GetTruckType(type: any) {
    this.truckTypeNumber = type;
    this.services.GetTrucksType(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  truckCategoryGet(tripType: any, type: any) {
    this.loading = true;
    this.services
      .GetCategory(
        this.token,
        this.truckTypeNumber,
        this.perPage,
        this.startPage
      )
      .subscribe((response: any) => {
        this.loading = false;
        this.truckCategory = response.body.data;
      });
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty = this.notifyform.value.max_trips * this.workOrderQnty;
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.notifyform.patchValue({
        remaining_tons: this.work_order_qty,
      });
    } else {
      this.notifyform.patchValue({
        remaining_tons: this.notifyform.value.remaining_tons,
      });
      this.snackBar.open(
        "Work Order total tons Should not Exceed With Actual total Tons",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }
  formatDate(str: any) {
    const date = new Date(str);
    return String(date.toLocaleDateString());
  }

  getTruckTypeId(truckCategory: string): string | null {
    const truckType = this.truckTypeList.find(
      (truck: any) => truck.category === truckCategory
    );
    return truckType ? truckType._id : null;
  }

  notify(event: any) {
    // if (this.notifyform.invalid) {
    //   this.snackBar.open("Please fill all the mandatory fields", "Fail", {
    //     duration: 5000,
    //   });
    //   return;
    // }
    if (!this.notifyform.valid || this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly

    if (this.selectedLoadedQuantity != true) {
      this.radioButtonSelected =
        this.notifyform.value.notification_radius ||
        this.notifyform.value.truck_home_location;
      if (!this.radioButtonSelected) {
        this.snackBar.open(
          "Please select one of the notification options",
          "Fail",
          {
            duration: 5000,
          }
        );
        return;
      }
    } else if (this.radioButtonSelected == "") {
      this.snackBar.open("Please enter the selected value", "fail", {
        duration: 5000,
      });
      return;
    }
    const truckCategory = this.notifyform.value.truck_category;
    const tripId = this.getTruckTypeId(truckCategory);

    const notifyObj = {
      work_order_quantity: this.notifyform.value.work_order_quantity,
      workorder_id: this.notifyform.value.workorder_id,
      // trip_id: tripId,
      from_city_name: this.notifyform.value.from_city_name,
      to_city_name: this.notifyform.value.to_city_name,
      trip_booking_date: formatDate(
        this.notifyform.value.trip_booking_date,
        "yyyy-MM-dd",
        "en"
      ),
      truck_category: this.notifyform.value.truck_category_name,
      truck_weight: Number(this.notifyform.value.truck_weight),
      max_trip: this.notifyform.value.max_trip,
      load_details: this.notifyform.value.material_type,
      notification_radius:
        Number(this.notifyform.value.notification_radius) || "",
      truck_home_location: this.notifyform.value.truck_home_location || "",
      timer: Number(this.notifyform.value.timer) || "",
      all_transporters: this.selectedLoadedQuantity || false,
    };

    if (notifyObj.truck_weight === 0) {
      this.snackBar.open("Please enter valid truck weight", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (
      Number(notifyObj.max_trip) * notifyObj.truck_weight >
      this.gettingData.total_tons
    ) {
      this.snackBar.open("The weight should not exceed with total tons", "Ok", {
        duration: 5000,
      });
      return;
    }
    if (notifyObj.timer === 0 || notifyObj.timer == "") {
      this.snackBar.open("Please enter valid timer", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.services.notifPushDriver(notifyObj, this.token).subscribe(
      (response: any) => {
        this.loading = true;
        if (response.status == 200) {
          this.matdialogref.close({ event: "Success" });
          this.snackBar.open(
            "Push notification has been informed to near by drivers",
            "Success",
            {
              duration: 5000,
            }
          );
          this.workOrder();
        }
        setTimeout(() => {
          this.loading = false; // ✅ Enable button after response
          (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
        }, 500);
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  selectLoadedQty(event: any) {
    this.selectedLoadedQuantity = event === "true" || event === true;
  }
}
